<script setup lang="ts">
  import { Label } from "@/components/ui/label";

  defineProps<{
    label: string;
  }>();
</script>

<template>
  <div class="mb-4 space-y-2">
    <Label>{{ label }}</Label>
    <div class="w-full">
      <slot />
    </div>
  </div>
</template>
